<template>
  <div
    class="dynamic-content"
    v-if="content"
    v-html="content"
  >
  </div>
</template>

<script>
export default {
  name: "DynamicContent",

  props: {
    content: {
      type: String,
    },
  },
};
</script>

<style scoped>
.dynamic-content {
  width: 100%;  
}
</style>


// WEBPACK FOOTER //
// Content.vue?37276b40